import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[cr-input]' // tslint:disable-line
})
export class CirrusInputDirective {
  public readonly baseClass: string = 'cr-input';
  private classNames = '';

  constructor() {
    this.classNames = this.baseClass;
  }

  @HostBinding('class')
  public get className(): string {
    return this.classNames;
  }

  public set className(newClassNames: string) {
    const classes: Set<string> = new Set([newClassNames]);
    classes.add(this.baseClass);
    this.classNames = Array.from(classes).join(' ');
  }
}
